module.exports = __webpack_public_path__ + "static/img/api2.153ced2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/api2.png
// module id = aQOv
// module chunks = 1